<template>
  <div class="details_form_item">
    <Form ref="editModel" :model="editModel" :label-width="100">
      <FormItem label="设备SN码：">{{editModel.clientSN}}</FormItem>
      <FormItem label="设备名称：">{{editModel.clientName}}</FormItem>
      <FormItem label="设备类型：">{{editModel.clientType}}</FormItem>
      <FormItem label="产品类型">{{editModel.projectName}}</FormItem>
      <FormItem label="所属主设备">{{editModel.mainClientName}}</FormItem>
      <FormItem label="所属机构：">{{editModel.organName}}</FormItem>
      <FormItem label="描述信息：">{{editModel.clientDescription}}</FormItem>
      <FormItem label="是否激活：">{{editModel.isActived== "0" ? "否" : "是"}}</FormItem>

    </Form>
    <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currentData"],
  data: function () {
    return {
      organParentName: "",
      editModel: {},
    };
  },

  created: function () {
    this.editModel = this.currentData;
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
</style>